export default __webpack_public_path__ + "static/media/github.00b39fd7.svg";